<template>

  <div class="card" style="width: 25rem" 
  v-if="this.quantity>0"
  > 
    <h3>{{ nftTitle }} </h3>
  
    <form @submit.prevent="submitForm">
      <img
      class="card-img-top"
      :src="nftImg"
      style="height: 20rem"
      height="320"
    />
    <!-- <p class="card-text">Price : {{ nftPrice*2 }} BTC </p> -->
    <br>    <br>
    <button class="button" @click="sellNFT"> SELL </button>
    </form>
  </div>
</template>

<script>
import { app } from "../main.js";
import AxiosService from "../services/AxiosService.js";
import axios from "axios"
export default {

  inject:["listedNFTs"],
  props: ["nftId", "nftTitle", "nftImg", "nftPrice", "isListed"],
  // emits: ["update-wallet"],

  data() {
    return {
      quantity: 0,
    };
  },
  mounted() {
    this.getResult();
  },
  methods: {
    sellNFT(){
    //  this.$emit("update-wallet", this.nftPrice);  
      AxiosService.getPreRegis()
        .then((response) => {
            const data = response.data;
            let x = "";
            for (const frbId in data){
                if(data[frbId].nftId === this.nftId && data[frbId].user === app.config.globalProperties.$displayName){
                    x = frbId;
                    break;
                }
            }
            const baseURL = "https://iccs340-project-4c21f-default-rtdb.asia-southeast1.firebasedatabase.app/myNFTs/";
            axios.delete(baseURL + x +".json?auth=" + app.config.globalProperties.$idToken);
        }).catch((error) => {
            console.log(error);
      });  
      this.quantity = 0;
      alert("The NFT is now listed for sale in the market");
    },
    getResult() {
      AxiosService.getPreRegis()
        .then((response) => {
          const data = response.data;
          for (const frbId in data) {
            if(data[frbId].nftId === this.nftId && data[frbId].user === app.config.globalProperties.$displayName ){
              this.quantity = 1;
            }
          } 
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>

.button {
  background-color: orangered;
  border: 3p;
  border-color: black;
  color:white;
  font-family:Arial, Helvetica, sans-serif;
  border-radius: 3px;
  font-size: 1.3rem;
}

.button:hover {
  background-color:white;
  border: 3p;
  color:orangered;
  font-family:Arial, Helvetica, sans-serif;
  border-radius: 3px;
  font-size: 1.3rem;
}

.card {
  /* margin: 5px 2px; */
  box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
  height: 29rem;
  display: inline-block;
  width: 350px;
  text-align: center;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 5px gray;
  font-family: Arial, Helvetica, sans-serif;
}

p {
  display: inline-block;
  padding-left: 25px;
  font-family: Arial, Helvetica, sans-serif;
}

</style>